import { strToDisplayName, parseJSON, htmlParser } from "common/string-helper";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import "./RecipeLists.css";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    position: "relative",
    height: "100%",
    boxShadow: "0px 32px 64px rgba(6, 23, 50, 0.08)",
    borderRadius: 5,
  },
}));


const Recipe = ({ 
  recipe, 
}) => {
  const classes = useStyles();
  let roles = parseJSON(recipe.role);
  let industries = parseJSON(recipe.industry);
  let platforms = parseJSON(recipe.platforms);
  let usecases = parseJSON(recipe.usecases);

  let tags = [];

  for(let i = 0; i < roles.length; i++) {
    let role = roles[i];
    if(role !== "") tags.push(strToDisplayName(role));
  }

  for(let i = 0; i < industries.length; i++) {
    let industry = industries[i];
    if(industry !== "") {
      tags.push(strToDisplayName(industry));
    }
  }

  for(let i = 0; i < platforms.length; i++) {
    let platform = platforms[i];
    if(platform !== "") tags.push(strToDisplayName(platform));
  }


  for(let i = 0; i < usecases.length; i++) {
    let usecase = usecases[i];
    if(usecase !== "") tags.push(strToDisplayName(usecase));
  }

 let gridSz = (tags.length >= 1) ? 12 : 6;

  return ( 
      <Grid item xs={12} sm={gridSz} className="react-RecipePanelContainer" > 
        
        <div style={{ height: '100%' }} >
          <a style={{textDecoration: "none"}} href={recipe.link}>
            <Paper className={classes.paper}> 
            <div className="react-RecipePanelContainer">
                  <div className="recipe-panel-image">
                    <img className="react-RecipeImageContainer" src={recipe.recipeImage} alt="Recipe List"/>
                  </div>
                    <div className="react-RecipeInnerPadding">
                      <div className="react-RecipeTagsContainer">
                          {tags.map((tag, index) => (
                            <div className="react-RecipeTagOption" key={index}>
                              <div className="react-RecipeTagOptionText">{strToDisplayName(tag)}</div>
                            </div>
                          ))}
                      </div>
                      <div className="react-RecipeTitle">
                        {htmlParser(recipe.title)}
                      </div>
                      <div className="react-RecipeContent">
                        {htmlParser(recipe.content)}
                      </div>
                    </div>
                    <div className="react-RecipeBtnContainer">
                      <a href={recipe.link} style={{textDecoration: "none"}}>
                      <div className="react-RecipeBtnText">
                        Learn More
                      </div> 
                      </a>
                    </div>
                    <div className="react-RecipeAuthorContainer"> 
                      <img className="react-RecipeAuthorImg" src={recipe.authorImage} alt="Author"/>
                      <div className="react-RecipeAuthorNameContainer">
                        <div className="react-RecipeByText">By</div> 
                        <div className="react-RecipeAuthorName">
                          {strToDisplayName(recipe.authorName)}
                        </div>
                      </div>
                    </div>

                  </div>
            </Paper>
          </a>
        </div>
      </Grid>
   );
}
 
export default Recipe;